import type {AlbumPhotoFaceProps, AlbumPhotoSortBy, AttrMultiWatermark, PhotoOutlineProps, SortType, DownPhotoQuality} from '@/views/props'
import {defineStore} from 'pinia'

interface Props {
    albumId: string
    photoList: PhotoOutlineProps[]
    pages: number
    pageSize: number
    labelId: number
    sortBy: AlbumPhotoSortBy
    sortType: SortType
    albumWatermark: AttrMultiWatermark[]
    currentIndex: number
    personList: AlbumPhotoFaceProps[]
    personId: string
    showPerson: boolean
    showWatermark: boolean
    downPhotoQuality: DownPhotoQuality
    debug: boolean
    puzzle: boolean
    formMini: boolean
    gatherId: string
    sharePoster: boolean
    cndUrl: string
    processUrl: string
    loadingUrl: string
    loadingSize: number
    openPhotoHome: boolean
    openUserHome: boolean
    screenWidth: number | undefined
    screenHeight: number | undefined
    userHomeId: number | undefined
    openId: string | undefined
    payPhotoType: 'NONE' | 'PAY_PHOTO' | 'SELECT_PHOTO'
    canDownload: boolean
    vote: boolean
    voteStartTime: string
    voteEndTime: string
    voteResult: boolean
    forceMode: 'NONE' | 'FACE' | 'NUMBER' | 'FILE_NAME'
    forceModeDesc:string,
    gatherId_en:number[],
    albumId_en:string[]
}

export const useAlbumStore = defineStore({
    id: 'album',

    state: (): Props => ({
        albumId: '',
        photoList: [],
        pages: 0,
        pageSize: 50,
        labelId: 0,
        sortBy: 'CAPTURE_TIME',
        sortType: 'DESC',
        albumWatermark: [],
        currentIndex: 0,
        personList: [],
        personId: '',
        showPerson: true,
        showWatermark: true,
        downPhotoQuality: 'ORIGIN',
        debug: false,
        puzzle: false,
        formMini: false,
        gatherId: '0',
        sharePoster: false,
        cndUrl: '',
        processUrl: '',
        // albumLoading: true,
        openPhotoHome: false, // 图片详情页的个人主页入口是否显示
        openUserHome: false, // 相册首页的个人主页入口是否显示
        screenWidth: undefined, // 屏幕宽度
        screenHeight: undefined, // 屏幕高度
        userHomeId: undefined,
        openId: undefined,
        // payPhoto: false,  // 是否开启付费
        canDownload: false,
        payPhotoType: 'NONE',
        loadingUrl: '',
        loadingSize: 50,
        vote: false,
        voteStartTime: '',
        voteEndTime: '',
        voteResult: false,
        forceMode: 'NONE',
        forceModeDesc:'',
        gatherId_en:[674],
        albumId_en:['67e4f0d7d0b24afa8f0ad2205b28808e','b3f80e7bc5a94df3ad235de8aa314034','0e9ec3e1165a417bb884442a355fae27','4de8cc40e1c940458349c448e9119ddb','b913dc023bed4d1a84e511360afc0060'
            ,'87592bdf18b54b96ba66f149ca4f607e','07c803c6ad244bf8a4f1e3ff76fcdff5','279d7fac0967462b9ae1e6ba33e4b474','f2144288ad274d77862bdaf40221818f','f202ae9f35e74309acc44dcfdb8f7e88',
            '1c3a180a08b24da39db89e0cfc1db6df','c7874dcbc59d44d58b05881a62ef2f4a','d48c3b90ca894543aa6da3bc12c21227'
        ]
    }),
    // 开启数据持久化
    persist: {
        enabled: true,
        strategies: [
            {
                key: 'store',
                storage: sessionStorage
            }
        ]
    },
    getters: {
        getAlbumId: (state: Props) => state.albumId,
        getPhotoList: (state: Props) => state.photoList,
        getPersonList: (state: Props) => state.personList
    },
    actions: {
        setScreenWidth(newValue) {
            this.screenWidth = newValue
        },
        setScreenHeight(newValue) {
            this.screenHeight = newValue
        }
    }
})
